import { Enum } from './Enum';

export class CCMCallStatus extends Enum {
  translationKey = 'ccmCallStatus';

  static asArray: CCMCallStatus[] = [];

  static byKey: { [name: string]: CCMCallStatus } = {};

  static readonly COMPLETED = new CCMCallStatus('COMPLETED');

  static readonly ATTEMPTED = new CCMCallStatus('ATTEMPTED');

  static readonly NOT_STARTED = new CCMCallStatus('NOT_STARTED');

  constructor(public readonly value: string) {
    super();
    CCMCallStatus.asArray.push(this);
    CCMCallStatus.byKey[value] = this;
  }
}

export default CCMCallStatus;
